export const backendUrl = import.meta.env.VITE_APP_BACKEND_URL;
export const authorizationUrl = import.meta.env.VITE_APP_AUTHORIZATION_URL;
export const redirectUrl = `${window.location.origin}/webhook/sign-in/`;
export const clientAppId = import.meta.env.VITE_APP_CLIENT_APP_ID;
export const scope = import.meta.env.VITE_APP_CLIENT_SCOPE;
